import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import NoteDS2SemUn from "./NoteDS2SemUn"
import NoteDS2SemDeux from "./NoteDS2SemDeux";
import ListEmergementVierge from "./ListEmergementVierge";

const NoteDS2 = props => {
  const [section, setSection] = useState(1)

  const renderBlock = section => {
    if (section === 1) {
      return <NoteDS2SemUn />
    }else if(section ===2){
      return <NoteDS2SemDeux />
    }else if(section === 3 ){
      return <ListEmergementVierge/>
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DS2 | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Semstre 1")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Semestre 2")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 3,
                    })}
                    onClick={() => {
                      setSection(3)
                    }}
                >
                  {props.t("Liste Émergement Vierge")}
                </NavLink>
              </NavItem>
            </Nav>
            {renderBlock(section)}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

NoteDS2.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(NoteDS2))
